import React from 'react'
import './Filter.scss'

import filterShape from '../../Assets/home/filter.svg'
import activeFilterShape from '../../Assets/home/filter_active.svg'

import FilterTool from '../../Assets/home/filter_tool.svg'

function Filter(props){
  
  function filterElem(e){
    let elems = document.querySelectorAll('.filters .filter')
    for(let x=0; x<elems.length; x++){
      elems[x].style.background = `url(${filterShape}) no-repeat center`;
      elems[x].classList.remove('active');
    }
    e.target.style.background = `url(${activeFilterShape}) no-repeat center`;
    e.target.classList.add('active')
  }
  
  const filters = props.arr.map((el, index) => {
    return(
      <button key={index} onClick={(e) => filterElem(e)} className={el.active ? 'active filter' : 'filter'}>{el.title}</button>
    )
  })

  return(
    <div className={props.darkMode ? "filters_wrapper dark" : "filters_wrapper"}>
      <div className="filters">
        {filters}
      </div>
      <button className="filter charity">Charity</button>
      <button className="filter">
        <img src={FilterTool} alt="filter tool"/>
          Filters
        </button>
    </div>

  )
}

export default Filter;